"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeTextToFraction = exports.replaceAll = exports.spacyFractionToText = exports.textToFraction = exports.fractionToText = void 0;
const toPairs_1 = require("../toPairs");
exports.fractionToText = {
    "½": "1/2",
    "⅓": "1/3",
    "⅔": "2/3",
    "¼": "1/4",
    "¾": "3/4",
    "⅕": "1/5",
    "⅖": "2/5",
    "⅗": "3/5",
    "⅘": "4/5",
    "⅙": "1/6",
    "⅚": "5/6",
    "⅐": "1/7",
    "⅛": "1/8",
    "⅜": "3/8",
    "⅝": "5/8",
    "⅞": "7/8",
    "⅑": "1/9",
    "⅒": "1/10",
};
const invert = (obj) => {
    const newObj = {};
    toPairs_1.toPairs(obj).forEach(([k, v]) => {
        newObj[v] = k;
    });
    return newObj;
};
exports.textToFraction = toPairs_1.toPairs(invert(exports.fractionToText)).reduce((acc, [k, v]) => {
    acc[k] = v;
    acc[` ${k}`] = v;
    return acc;
}, {});
exports.spacyFractionToText = {};
toPairs_1.toPairs(exports.fractionToText).map(([k, v]) => {
    exports.spacyFractionToText[k] = ` ${v} `;
});
exports.replaceAll = (str, mapObj) => {
    const re = new RegExp(Object.keys(mapObj).join("|"), "gi");
    return str.replace(re, matched => mapObj[matched.toLowerCase()]);
};
exports.safeTextToFraction = (x) => {
    const y = exports.textToFraction[x];
    return y || x;
};
//# sourceMappingURL=index.js.map